var module = angular.module('octopusApp.infrastructure');

// A service that helps for building screens that auto-refresh from a service.
// You create a loop by attaching it to your scope (it will automatically stop looping
// when your scope is destroyed by Angular) and giving it a callback.
//
//   var loop = pollLoop.create($scope, function () {
//     return doSomethingThatReturnsAPromise();
//   });
//
// Start the loop using:
//
//   loop.start();                or
//   loop.startImmediately();
//
// The callback must return a promise. The loop will set a timeout to run again once
// the promise completes (success or fail) - that way if you have a 3 second poll loop,
// the 3 seconds starts from when your service call finishes, not from when it started.
//
// When you're finished polling, you can use:
//
//   loop.stop();
//
module.factory('pollLoop', function ($timeout, octopusLog) {
  return {
    create: function ($scope, callbackThatReturnsAPromise, timeout) {
      if (!timeout) {
        timeout = 4000;
      }

      var instance = {};
      instance.activeId = 0;
      instance.isRunning = false;

      $scope.$on('$destroy', function () {
        instance.isRunning = false;
        //octopusLog.info("Poll loop destroyed");
      });

      instance.stop = function() {
        instance.isRunning = false;
      };

      var startInternal = function (immediate) {
        instance.activeId++;
        var id = instance.activeId;
        if (instance.isRunning) {
          return;
        }

        instance.isRunning = true;

        var firstTime = true;

        var doTimeout = function () {
          $timeout(function () {
            loop();
          }, timeout);
        };

        var loop = function() {
          if (!instance.isRunning || id !== instance.activeId) {
            return;
          }

          if (!firstTime || immediate) {
            var prom = callbackThatReturnsAPromise();
            if (!prom) {
              octopusLog.error("The poll loop callback should return a promise");
            } else {
              prom.then(function () {
                doTimeout();
              }, function () {
                doTimeout();
              });
            }
          } else if (firstTime && !immediate) {
            doTimeout();
          }

          firstTime = false;
        };

        loop();
      };

      instance.startImmediately = function () {
        startInternal(true);
      };

      instance.start = function () {
        startInternal(false);
      };

      return instance;
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/services/poll_loop.js
// module id = 705
// module chunks = 1